import { PLAN_ACTIVATION_DATA_LOCALSTORAGE_KEY } from './constants';
import { PlanActivationStoredData } from './types';

export const getPlanActivationEmail = () => {
  const planDataString = localStorage.getItem(PLAN_ACTIVATION_DATA_LOCALSTORAGE_KEY);
  const { email } = JSON.parse(planDataString || '{}') as Partial<PlanActivationStoredData>;
  return email;
};
